// extracted by mini-css-extract-plugin
module.exports = {"container":"navigation-module--container--1YrOV","logo":"navigation-module--logo--3pVjt","list":"navigation-module--list--38jzo","shops":"navigation-module--shops--1hijz"};